import React, { useState, useEffect } from "react";

import { Tabs, Table, message } from "antd";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./Visitor.module.less";

function Visitor() {
  const [visitLoading, setVisitLoading] = useState(true);
  const [visitData, setVisitData] = useState({});
  const [visitPagination, setVisitPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [statLoading, setStatLoading] = useState(true);
  const [statData, setStatData] = useState([]);
  const [statPagination, setStatPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { TabPane } = Tabs;

  const columnsVisit = [
    {
      title: "访问时间",
      dataIndex: "createdTime",
      key: "createdTime",
      ellipsis: true,
    },
    {
      title: "城市",
      dataIndex: "city",
      key: "city",
      ellipsis: true,
      render: (value, data) => (
        <span>{`${data.country}${data.region ? " / " + data.region : ""}${
          value ? " / " + value : ""
        }${data.isp ? " / " + data.isp : ""}`}</span>
      ),
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      ellipsis: true,
    },
    {
      title: "浏览器",
      dataIndex: "",
      key: "x",
      ellipsis: true,
      render: (data) => (
        <span>
          {`${data.browser}${
            data.browserMajorVersion ? " - " + data.browserMajorVersion : null
          }`}
        </span>
      ),
    },
    {
      title: "平台",
      dataIndex: "platform",
      key: "platform",
      ellipsis: true,
      render: (value, data) => (
        <span>
          {`${value}${
            data.platformVersion ? " - " + data.platformVersion : null
          }`}
        </span>
      ),
    },
    {
      title: "入口页",
      dataIndex: "landPage",
      key: "landPage",
      ellipsis: true,
    },
    {
      title: "来源页",
      dataIndex: "sourcePage",
      key: "sourcePage",
      ellipsis: true,
    },
  ];

  const columnsStat = [
    {
      title: "时间",
      dataIndex: "date",
      key: "date",
      ellipsis: true,
    },
    {
      title: "访问量",
      dataIndex: "hits",
      key: "hits",
      ellipsis: true,
    },
    {
      title: "PV",
      dataIndex: "pv",
      key: "pv",
      ellipsis: true,
    },
    {
      title: "UV",
      dataIndex: "uv",
      key: "uv",
      ellipsis: true,
    },
  ];

  const getVisitList = async (params) => {
    setVisitLoading(true);
    try {
      let para = queryString.stringify({
        pageNumber: params.visitPagination.current,
        pageSize: params.visitPagination.pageSize,
      });
      let parsed = await Http.get(`visitor`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        setVisitData(parsed.result);
        setVisitPagination({
          current: parsed.result.pageNumber,
          pageSize: parsed.result.pageSize,
          total: parsed.result.totalRow,
        });
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setVisitLoading(false);
    }
  };

  const getStatList = async (params) => {
    setStatLoading(true);
    try {
      let para = queryString.stringify({
        pageNumber: params.statPagination.current,
        pageSize: params.statPagination.pageSize,
      });
      let parsed = await Http.get(`stat`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        setStatData(parsed.result);
        setStatPagination({
          current: parsed.result.pageNumber,
          pageSize: parsed.result.pageSize,
          total: parsed.result.totalRow,
        });
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    getVisitList({ visitPagination });
    getStatList({ statPagination });
  }, []);

  return (
    <div className={styles.Visitor}>
      <Tabs defaultActiveKey="1" type="card">
        <TabPane tab="访问明细" key="1">
          <Table
            loading={visitLoading}
            rowKey="id"
            rowSelection={{ type: "checkbox" }}
            onChange={(p) => {
              getVisitList({ visitPagination: p });
            }}
            dataSource={visitData.list}
            columns={columnsVisit}
            pagination={visitPagination}
          />
        </TabPane>
        <TabPane tab="日段分析" key="2">
          <Table
            loading={statLoading}
            rowKey="id"
            rowSelection={{ type: "checkbox" }}
            onChange={(p) => {
              getStatList({ statPagination: p });
            }}
            dataSource={statData.list}
            columns={columnsStat}
            pagination={statPagination}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}
export default Visitor;
